import type {PayloadAction} from "@reduxjs/toolkit";
import {createSlice} from "@reduxjs/toolkit";

interface StateProps {
    isLoading: boolean;
}

const initialState: StateProps = {
    isLoading: false,
};

export const emailMakerAiRedesignPromptBoxSlice = createSlice({
    name: 'emailMakerAiRedesignPromptBox',
    initialState,
    reducers: {
        setIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    }
})

export const {setIsLoading} = emailMakerAiRedesignPromptBoxSlice.actions;

export const emailMakerAiRedesignPromptBoxReducer = emailMakerAiRedesignPromptBoxSlice.reducer;